/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Item, Grid, Header } from 'semantic-ui-react';
import './ItemCollection.css';

export default class ItemCollection extends React.Component {
  getItems() {
    const { itemsPerRow, onlyEvenRows, children } = this.props;

    if (onlyEvenRows && children.length >= itemsPerRow) {
      return children.slice(0, Math.floor(children.length / itemsPerRow) * itemsPerRow);
    }

    return children;
  }

  getHeaderStyle() {
    const { collectionType } = this.props;

    if (collectionType === 'custom') return { marginLeft: '0.5em', marginRight: '1.5em' };

    return {};
  }

  renderGridCollection() {
    const { itemsDivided, itemsPerRow } = this.props;

    return (
      <Grid stackable columns={itemsPerRow} celled={itemsDivided && 'internally'}>
        {this.getItems().map((item, index) => (
          <Grid.Column key={index}>{item}</Grid.Column>
        ))}
      </Grid>
    );
  }

  renderItemCollection() {
    const { itemsDivided } = this.props;

    return (
      <Item.Group relaxed divided={itemsDivided}>
        {this.getItems()}
      </Item.Group>
    );
  }

  renderCardCollection() {
    const { itemsPerRow } = this.props;

    return (
      <Card.Group itemsPerRow={itemsPerRow} stackable fluid>
        {this.getItems()}
      </Card.Group>
    );
  }

  renderCollection() {
    const { collectionType } = this.props;
    if (collectionType === 'cards') return this.renderCardCollection();
    if (collectionType === 'items') return this.renderItemCollection();
    if (collectionType === 'custom') return this.renderGridCollection();

    return <div />;
  }

  render() {
    const { header, centerHeader, className } = this.props;

    return (
      <div className={className}>
        {header && (
          <Header
            as="h1"
            textAlign={centerHeader ? 'center' : 'left'}
            style={this.getHeaderStyle()}
          >
            {header}
          </Header>
        )}
        {this.renderCollection()}
      </div>
    );
  }
}

ItemCollection.propTypes = {
  collectionType: PropTypes.oneOf(['cards', 'items', 'custom']).isRequired,
  itemsPerRow: PropTypes.number,
  itemsDivided: PropTypes.bool,
  header: PropTypes.string,
  centerHeader: PropTypes.bool,
  onlyEvenRows: PropTypes.bool,
  className: PropTypes.string
};

ItemCollection.defaultProps = {
  centerHeader: false,
  header: '',
  itemsDivided: false,
  itemsPerRow: 3,
  onlyEvenRows: false,
  className: ''
};

ItemCollection.propOptions = {};

ItemCollection.dataPropsMap = {};
